<template>
  <div>
    <b-row>
      <b-col md="12">
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
                <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="10%" style="background-color:#f1f1f1">
                        <label class="col-form-label">활성기간</label>
                      </td>
                      <td width="40%" class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="12">
                            <b-form-input type="text" name="daterange_topbanner" />
                          </b-col>
                        </b-row>
                      </td>
                      <td width="10%" style="background-color:#f1f1f1">
                        <label class="col-form-label">이미지 업로드<br/>(1240 X 70)</label>
                      </td>
                      <td width="40%" class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="2">
                            <div :class="imgFileCheck ? 'imgfile' : 'imgfilenone'">
                              <input type="file" class="form-control-file" id="file_Top" ref="file" accept=".jpg, .jpeg, .png" style="padding:5px;display:none;" v-on:change="handleFileUpload('MAIN_FILE')"/>
                              <input type="button" id="btn-upload_Top" value=" 업로드 " style="padding:5px"  v-on:click="fileUploadModule()"/>
                            </div>
                            <div><b id="imgnone_topbanner" style="display:inline-block; background:#ea0000; padding:7px 10px; margin:0 0 0 10px; border-radius:5px; color:#ffffff; font-size:14px; float:left">이미지는 필수로 등록해주세요.</b></div>
                          </b-col>
                          <b-col sm="3">
                            <div>
                              <b-form-input id="contents_html_Text" name="contents_html" type="text" v-model="queryParams.contents_html" v-validate="'required'" :class="{'is-invalid': errors.has('contents_html')}"></b-form-input>
                              이미지 양끝 색상
                            </div>
                          </b-col>
                          <b-col sm="5">
                          </b-col>
                          <b-col sm="2">
                            <a href="javascript:void(0)" v-on:click="topBannerPreview()"><u>미리보기</u></a>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">URL</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="12">
                            <b-form-input id="basicText" name="landingurl" type="text" v-model="queryParams.landing_url" v-validate="'required'" :class="{'is-invalid': errors.has('landingurl')}"></b-form-input>
                            <span v-show="errors.has('landingurl')" :class="{error: errors.has('landingurl')}">랜딩 URL은 필수 항목 입니다.</span>
                          </b-col>
                        </b-row>
                      </td>
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">활성화</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="12">
                            <c-switch type="text" variant="primary" v-model="queryParams.active_yn" on="On" off="Off" :pill="true" :checked="true" style="margin:0px"/>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                </tbody>
            </table>
          </div>
      </b-col>
    </b-row>
    <!-- /////////////////////////////////////////// -->
    <!-- 팝업 -->
    <section id="topBanner1" class="popup" style="max-width:1240px;max-height:70px">
    	<div class="container_pop" >
    		<!-- 이미지는 가로 500px -->
		    <img :src="queryParams.img_url">
    		<!-- <p>
    			팝업 내용. 텍스트는  p테그 안에 넣어주세요
    		</p> -->
      </div>
    	<div class="hide_pop">
    		<!-- <a v-on:click="closePopupNotToday()">오늘하루 그만보기</a> -->
    		<a v-on:click="hide_pop()">닫기</a>
      </div>
    </section>
    <!-- / -->
  </div>
</template>
<script>
import Vue from 'vue';
import datetimepicker from "daterangepicker/daterangepicker.js";
import ko from 'vee-validate/dist/locale/ko.js'
import swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import cSwitch from '../../components/Switch'

const moment = require("moment");

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  locale: 'ko'
});

export default {
  components: {
    Multiselect,
    cSwitch
  },
  props: {
    queryParams: {
    },
  },
  data() {
    return {
      imgFileCheck: true,
      newslettercode: '',
      newFlag:'new',
      pageOptions: [5, 10, 30, 50, 100],
      ratingOptions: [], // 평가시 적립 포인트 코드 조회 => 평가시 적립 포인트 선택
      ratingPointData: '',
      formtype: '',
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
      endDate: moment().format('YYYY-MM-DD'),
      startDate: moment().format('YYYY-MM-DD'),
      enabled: true,
    }
  },
  watch: {
  },
  mounted: function() {
    $("#topBanner1").hide('fade');

    $("#imgnone_topbanner").hide();
    var token = sessionStorage.getItem("myToken");
    var self = this;
    self.formtype = self.$route.query.status;

    $(function() {
      $(".imgnone").hide();
      setTimeout(function(){
          $('input[name="daterange_topbanner"]').daterangepicker({
            opens: 'left',
            "locale": self.calendarLocale,
            "endDate": self.queryParams.end_date,
            "startDate": self.queryParams.start_date
          }, function(start, end, label) {
            self.queryParams.start_date = start.format('YYYY-MM-DD');
            self.queryParams.end_date = end.format('YYYY-MM-DD');
          });
        }, 300);
    });
  },
  methods: {
    fileUploadModule(){
      $('#file_Top').click();
    },
    hide_pop(){
      $("#topBanner1").hide('fade');
    },
    topBannerPreview(){
      $("#topBanner1").show('fade');
    },
    validateCheckFN(){
      var self = this;
      this.$validator.validateAll().then(res=>{
        if(res){
            self.queryParams.formValidation = true;
        }else{
            self.queryParams.formValidation = false;
        }
        if(self.queryParams.listThumbnailFile.length == 0){
          $("#imgnone_topbanner").show();
          self.imgFileCheck = false;
          self.queryParams.formValidation = false & self.queryParams.formValidation;
        }else{
          $("#imgnone_topbanner").hide();
          self.imgFileCheck = true;
          self.queryParams.formValidation = true & self.queryParams.formValidation;
        }
      })
    },
    // 메소드명 : handleFileUpload()
    // ### 단일 파일업로드 ###
    // 한개의 파일 업로드를 진행한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  - fileType : 파일 타입
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    handleFileUpload(fileType){
      var self = this;
      self.queryParams.listThumbnailFile = [];
      var token = sessionStorage.getItem("myToken");
      self.file = self.$refs.file.files[0];
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('reportType', 'mainbanner');
      formData.append('fileSubPath', 'img');
      self.$http.post('/ftpserver/dropAndSingleFileUpload?access_token='+token, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((result) => {
          result.data.file_type_code = fileType;
          self.queryParams.listThumbnailFile.push(result.data);
          self.queryParams.listThumbnailFile.forEach(function (el, idx, arr){
            self.queryParams.img_url = el.file_url;
            self.queryParams.img_width = el.file_width;
            self.queryParams.img_height = el.file_height;
          });
          $("#imgnone_topbanner").hide();
          self.imgFileCheck = true;
          $("#imgcreat").hide();
          $("#imgdata").show();
          $("#imgdata").attr("src" ,self.queryParams.img_url);
          $("#imgdel").show();
      })

      this.validateCheckFN();
    },
    imgFileDelete(){
      var self = this;
      self.queryParams.listThumbnailFile = [];
      $("#imgcreat").show();
      $("#imgcreat").css("display", "table-cell");
      $("#imgdata").hide();
      $("#imgdata").attr("src", "");
      $("#imgdel").hide();
      $("#file").val('');
    }

  }
}

</script>
<style lang="css" scoped>
.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.p20{
    padding:20px
}

.normal {
    background-color: grey;
}

.dragArea{
    min-height: 10px;
}

.sortable-chosen {
    opacity: 0.7;
    background-color:#dcdcdc;
}

.sortable-ghost {
    background-color:#dcdcdc;
}
.handle {
    padding: 5px;
    margin-right: 10px;
    border: solid #000 1px;
    cursor: move;
}

span.error {
  color: #9F3A38;
}


#VueTables__search_UBume {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
<style src="daterangepicker/daterangepicker.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/main/BannerTopForm.vue